import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from 'uuid';
import {
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useGetAssignmentByVideoIdQuery,
  useGetAssignmentQuery,
} from "../../../features/assignment/assignmentApi";
import { endEditing } from "../../../features/assignment/assignmentSlice";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import useIsAssignmentExists from "../../../hooks/useIsAssignmentExists";
import Error from "../../ui/Error";

const AddModal = ({ open, control }) => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [video, setVideo] = useState(null);
  const [totalMark, setTotalMark] = useState("");
  const [checkAssignmentExist, setCheckAssignmentExist] = useState(false);

  // get the assignmentId to edit
  const { assignmentId, editMode } = useSelector((state) => state.assignment.editing);

  // get videos array
  const { data: videos, isLoading } = useGetVideosQuery();

  

  // get video data to populate form on edit mode
  const {
    data: assignmentInfo,
    isLoading: assignmentLoading,
    isError,
    refetch,
  } = useGetAssignmentQuery(assignmentId);

// get assginment by videoId to check if the selected video has already an assignment
  const {isAssignmentExist, assignment} = useIsAssignmentExists({video});


  // hook for edit assignment
  const [editAssignment, { isSuccess: editSuccess }] =
    useEditAssignmentMutation();

  //  get the hook to add new assignment
  const [addAssignment, { isSuccess:createSuccess }] = useAddAssignmentMutation();


  // form reset function
  const formReset = () => {
    setTitle("");
    setVideo(null);
    setTotalMark("");
  };

  useEffect(() => { 
    if ( assignmentInfo?.id) {
      const {
        title: initialTitle,
        totalMark: initialMark,
        video_title,
        video_id
      } = assignmentInfo;
      setTitle(initialTitle);
      setTotalMark(initialMark);
      setVideo({title: video_title, id: video_id})
    }
  }, [assignmentId, assignmentInfo]);


  useEffect(() => {
    if (createSuccess|| editSuccess) {
      refetch();
    }
  }, [createSuccess || editSuccess]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  //  function to check if selected video has assigned assignment
  const handleCheck = (e) => {
    const selectedOption = JSON.parse(e.target.value);
    setVideo(selectedOption);   
  };

  //  submit form to add new assignment
  const handleCreate = (e) => {
    e.preventDefault();

    if (!isAssignmentExist) {
      const data = {
        id: uuid(),
        title,
        video_title: video.title,
        video_id: video.id,
        totalMark,
      };

      addAssignment(data);
      closeModal()
    }
  };
  //  submit form to add new assignment
  const handleEdit = (e) => {
    e.preventDefault();

    if(!isAssignmentExist || assignment[0]?.id === assignmentInfo?.id){
      const data = {
        title,
        video_title: video.title,
        video_id: video.id,
        totalMark,
      };

    editAssignment({data, id:assignmentId});
    closeModal()
    }
    
  };

  const closeModal = () => {
    dispatch(endEditing());
    formReset();
    control();
  };

  return (
    open && (
      <main className="bg-secondary flex flex-col mx-8 p-8 form-modal">
        <h1 className="mb-10 text-center lws-section-title mt-8 text-2xl">
         {editMode ? "Edit Assignment" : "Add New Assignment"}
        </h1>

        <div className="max-w-3xl mx-auto mt-8">
          <form className="flex flex-col space-y-6" onSubmit={editMode ? handleEdit : handleCreate}>
            <div className="fieldContainer">
              <label>Assignment Title</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <input
                  type="text"
                  required
                  className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>
            <div className="fieldContainer">
              <label>Video</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <select
                  className="bg-secondary w-full h-8 px-3 rounded-md form-input"
                  required
                  value={JSON.stringify(video)}
                  onChange={handleCheck}
                >
                  {!editMode && <option value="" hidden selected>
                    Select Video
                  </option>}

                  {videos.map((option) => {
                    const {id, title} = option;
                   return (
                    <option key={id} value={JSON.stringify({title, id})}>
                    {title}
                    </option>
                  )})}
                </select>
              </div>
            </div>
            <div className="fieldContainer">
              <label>Total Mark</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <input
                  type="number"
                  required
                  className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                  placeholder="Mark"
                  value={totalMark}
                  onChange={(e) => setTotalMark(e.target.value)}
                  max={100}
                />
              </div>
            </div>
            <div className="flex justify-end space-x-4">
              <button
                onClick={closeModal}
                className="cursor-pointer btn bg-red-600 w-fit absolute"
                style={{ marginRight: "10px" }}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="lws-submit"
                className="cursor-pointer btn w-fit"
              >
               {editMode ? "Edit" : "Add"}
              </button>
            </div>
            {isAssignmentExist && assignment[0]?.id !== assignmentInfo?.id &&(
              <Error message="This video has already an assignment"/>
            )}
          </form>
        </div>
      </main>
    )
  );
};

export default AddModal;
